/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

let baseUrl = 'mi2c.com:8001/rpc'
let routerMode = 'hash'
let imgBaseUrl = ''
let isDev = true
let isPre = false
let cnzzSiteId = '1273752858' // mi2c online

if (process.env.NODE_ENV === 'development') {
  isDev = true
  cnzzSiteId = '1274332438' // testmi2c
  baseUrl = 'work.linux.com:8001/rpc'
  // baseUrl = 'pre-srv.mi2c.com/rpc'
  // baseUrl='work2.localhost.com:8000/rpc'
  // baseUrl = '47.105.181.27:8000/rpc'
  // baseUrl = 'wx-test.mi2c.com/rpc'
  // baseUrl = 'srv.mi2c.com/rpc'
  // baseUrl = 'wx-test.pijunxiao.cn/rpc'
  console.log(process.env.USERNAME)
  if (process.env.USERNAME === 'netsec') {
    // baseUrl = 'work1.localhost.com:8000/rpc'
    baseUrl = '47.105.181.27:8000/rpc'
  }
} else if (process.env.NODE_ENV === 'production') {
  isPre = process.env.HOST === 'pre'
  // baseUrl = isPre ? 'pre-srv.mi2c.com/rpc' : 'srv.mi2c.com/rpc'
  baseUrl = isPre ? 'pre-srv.pijunxiao.cn/rpc' : 'srv.mi2c.com/rpc'
  isDev = false
  if (isPre) {
    cnzzSiteId = '1274332438' // testmi2c
  }
}

baseUrl = window.location.protocol + '//' + baseUrl
// baseUrl = 'https://' + baseUrl

let statSiteId = '1'
let statUrl = baseUrl + '/stat/stat.js?siteid=1'

export {
  baseUrl,
  routerMode,
  imgBaseUrl,
  isDev,
  isPre,
  statUrl,
  statSiteId,
  cnzzSiteId
}



// WEBPACK FOOTER //
// ./src/common/env.js